import React from 'react'

export default function Item({children, label}) {
    return <li className={'timers-item'}>
        {children}
        <span>{label}</span>
    </li>
}